import { render, staticRenderFns } from "./MySavedItems.vue?vue&type=template&id=0f897559&scoped=true&"
import script from "./MySavedItems.vue?vue&type=script&lang=js&"
export * from "./MySavedItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f897559",
  null
  
)

export default component.exports